import * as React from "react";
import * as SwitchPrimitive from "@radix-ui/react-switch";
import styles from "./Switch.module.css";
import { cn } from "../../../utils/cn";

const Switch = ({
  className,
  ...props
}: React.ComponentProps<typeof SwitchPrimitive.Root>) => {
  return (
    <SwitchPrimitive.Root
      data-slot="switch"
      className={cn(styles.switch, className)}
      {...props}
    >
      <SwitchPrimitive.Thumb
        data-slot="switch-thumb"
        className={styles.thumb}
      />
    </SwitchPrimitive.Root>
  );
};

export { Switch };
